import { createContext } from 'react';

const useProductSamplingContext = createContext();
export default useProductSamplingContext;
